module.exports = __webpack_public_path__ + "img/face_error.8d89a4d4.svg";